module.exports = __webpack_public_path__ + "img/ct-en_ID-img.ca8a22d6.png";